import { Navigate } from 'react-router-dom'
import { ROUTES } from './routePaths'

export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem('hd_token')

  if (!token) {
    return <Navigate to={ROUTES.LOGIN} replace />
  }

  return children
}
